export function augmentTree2dElementEvent(e) {
    const node = e.element.data;
    const stage = node.stage;
    return Object.assign(Object.assign({}, e), { node, stage });
}
//# sourceMappingURL=tree2dEvents.js.map